import { render, staticRenderFns } from "./PhoneReqManage.vue?vue&type=template&id=96f85928"
import script from "./PhoneReqManage.vue?vue&type=script&lang=js"
export * from "./PhoneReqManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports